import { render, staticRenderFns } from "./warnTable.vue?vue&type=template&id=486e5bfa&scoped=true&"
import script from "./warnTable.vue?vue&type=script&lang=js&"
export * from "./warnTable.vue?vue&type=script&lang=js&"
import style0 from "./warnTable.vue?vue&type=style&index=0&id=486e5bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e5bfa",
  null
  
)

export default component.exports